import React from "react";
import PropTypes from "prop-types";
import { GeneralCheckmarksWrapper, Description } from "./style";
import { BulletPoint } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

const GeneralCheckmarks3 = (props) => {
	const {
		bulletPoints,
		header,
		description,
		subHeader,
		image,
		numberedBulletPoints,
		tipsPoints,
		tips,
	} = props;

	return (
		<GeneralCheckmarksWrapper imagePosition={image.position}>
			<h5>{header}</h5>
			<Description>{description}</Description>
			<div className="container">
				<div className="contentWrapper">
					<p className="subHeader">{subHeader}</p>
					<div>
						{tipsPoints
							? tips.map((tip, index) => (
									<p key={index} className="tip">
										<span className="tip-heading">{tip.heading}</span>
										{tip.description}
									</p>
								))
							: bulletPoints.map((text, index) => (
									<BulletPoint
										number={numberedBulletPoints && String(index + 1)}
										text={text}
										key={`${text}-${index}`}
									/>
								))}
					</div>
				</div>
				<div className="imageWrapper">
					<div className="imageContainer">
						{image.desktop && (
							<CloudinaryImage
								url={image.desktop.url}
								lazyload
								sizes={{
									default: {
										width: 400,
									},
								}}
							/>
						)}
					</div>
				</div>
			</div>
		</GeneralCheckmarksWrapper>
	);
};

GeneralCheckmarks3.propTypes = {
	bulletPoints: PropTypes.arrayOf(PropTypes.string),
	image: PropTypes.shape({
		position: PropTypes.oneOf(["left", "right"]),
		desktop: PropTypes.shape({
			url: PropTypes.string,
			altTag: PropTypes.string,
		}),
	}),
	header: PropTypes.string,
	numberedBulletPoints: PropTypes.bool,
	description: PropTypes.string,
	subHeader: PropTypes.string,
	tipsPoints: PropTypes.bool,
	tips: PropTypes.arrayOf(PropTypes.string),
};

GeneralCheckmarks3.defaultProps = {
	bulletPoints: [],
	header: "",
	description: "",
	subHeader: "",
	image: {
		position: "right",
		desktop: {
			url: null,
			altTag: "",
		},
	},
	numberedBulletPoints: false,
	tipsPoints: false,
	tips: [],
};

export default GeneralCheckmarks3;
